export const pinStyle = {
    position: "absolute",
    zIndex: "40",
    paddingTop: "20%",
    height: "100%",
    width: "100%",
    backgroundColor: "#eee",
};
